import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getApiBaseURL } from "../utils/api";

const SetupPassword = () => {
  const { user_id } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();
  const apiBase = getApiBaseURL();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage("❌ Passwords do not match.");
      return;
    }

    try {
      const res = await axios.post(`${apiBase}/api/auth/setup-password`, {
        user_id,
        password,
      });

      setMessage("✅ Password set successfully. Redirecting to login...");
      setTimeout(() => {
        navigate("/login"); // 🔁 Adjust this path if your login route is different
      }, 2000); // wait 2 seconds before redirecting
    } catch (err) {
      console.error("❌ Error setting password:", err);
      setMessage("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <div className="container mt-5">
      <h2>Set Up Your Password</h2>
      {message && <p className="fw-bold">{message}</p>}

      <form onSubmit={handleSubmit} className="col-md-6">
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Set Password
        </button>
      </form>
    </div>
  );
};

export default SetupPassword;
